export const StarRating = 3;
